import { useNotify } from '@hooks/useNotify';
import { createMemo } from '@packages/react';
import React from 'react';

/**
 * @author: Dumitrana Alinus <alin.designstudio@gmail.com>
 * @name: withErrorHandling
 * @type: HOC
 * @date:  16.02.2020
 * @time:  02:36
 */
export function withErrorHandling(WrappedComponent: any) {
    return createMemo(
        ({ ...rest }) => {
            const notify = useNotify();

            return (
                <WrappedComponent
                    {...rest}
                    notify={notify}
                    showError={notify.error}
                    showSuccess={notify.success}
                    showWarning={notify.warning}
                    showInfo={notify.info}
                />
            );
        },
        {
            displayName: `withErrorHandling(${WrappedComponent.displayName ?? 'Unknown'})`,
        },
    );
}

export default withErrorHandling;
